
import BaseAlert from "@/components/base/BaseAlert.vue";
import DepartureItem from "@/components/bookingflow/steps/departure/DepartureItem.vue";
import { getDurationInMinutes, HHmm } from "@/helpers/dateHelper";
import { DirectionEnum } from "@/models/enums";
import { DeparturePrice } from "@/models/www/DeparturePrice";
import {
	DepartureState,
	TicketTypeState,
} from "@/models/www/store/BookingState";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent, PropType } from "vue";
import BaseSpinner from "~/components/base/BaseSpinner.vue";

export default defineComponent({
	components: {
		DepartureItem,
		BaseSpinner,
		BaseAlert,
	},
	props: {
		departures: Object as PropType<DeparturePrice[]>,
		disabled: {
			type: Boolean,
			default: false,
		},
		direction: {
			type: Number as PropType<DirectionEnum>,
			required: true,
		},
		loading: Boolean,
	},
	setup(props) {
		const bookingStore = useBookingStore();
		const isLocked = computed(() => bookingStore.getIsLocked(props.direction));

		const departureInput = computed({
			get(): string {
				return bookingStore.getDeparture(props.direction)?.id;
			},
			set(value: string) {
				const previous = bookingStore.getDeparture(props.direction);
				const departure = props.departures?.find(
					(d) => d.departureId === value
				);

				//Clear extras if we're selecting a new departure, they may not be availble
				if (departure?.departureId && previous.id !== departure?.departureId) {
					bookingStore.updateResources(props.direction, []);
				}

				bookingStore.setDeparture(props.direction, {
					id: departure?.departureId,
					identifier: departure?.identifier,
				} as DepartureState);

				//sets the default ticketType
				//to the normal priced ticketType or the first bookable tickettype
				const standardTicketType =
					(departure?.ticketTypes ?? []).length > 0
						? departure?.ticketTypes.find((t) => t.bookable)
						: undefined;
				if (standardTicketType) {
					bookingStore.setDepartureTicketType(props.direction, {
						identifier: standardTicketType.identifier,
						type: standardTicketType.type,
						id: standardTicketType.id,
					} as TicketTypeState);
				}
			},
		});

		return {
			HHmm,
			getDurationInMinutes,
			departureInput,
			isLocked,
		};
	},
});
